import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { MatIconModule} from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';

/* Components */
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppRoutingModule } from './app-routing.module';
import { BookingComponent } from './booking/booking.component';
import { HotelComponent } from './hotel/hotel.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { LoginComponent } from './login/login.component';

/* Admin feature module */
//import { AdminModule } from './admin/admin.module';

/* Services */
import { LoginService } from './login/login.service';
import { UserComponent } from './user/user.component'

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    BookingComponent,
    HotelComponent,
    TransactionsComponent,
    LoginComponent,
    UserComponent
  ],
  imports: [
    BrowserModule,
    MatIconModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
    // AdminModule         // Feature module
  ],
  providers: [LoginService],
  bootstrap: [AppComponent]
})
export class AppModule { }
